import Box from '@mui/material/Box';
import { type ReactNode, useState } from 'react';
import { type MarketScope, useMarketLeaderboard } from '../data/api';
import { filterByCountries } from '../data/utils';
import { ErrorState } from '../shared/ErrorState';
import { MarketLeaderboardCard } from './MarketLeaderboardCard';
import type { TopMarketsSelection } from './TopMarketsControl';

export function MarketLeaderboard({
  scope,
  selectedCountries,
  enabled,
  topMarkets,
}: {
  scope: MarketScope;
  selectedCountries: string[];
  enabled: boolean;
  topMarkets: TopMarketsSelection;
}): ReactNode {
  const [weekStart, setWeekStart] = useState<string>();
  const { weeks, availableWeeks, currencySymbol, isLoading, isError } = useMarketLeaderboard(
    scope,
    enabled,
  );
  const latestWeek = weeks[weeks.length - 1];
  const selectedWeek = weeks.find((week) => week.weekStart === weekStart) ?? latestWeek;

  if (isError) return <ErrorState />;

  return (
    <>
      <Box sx={{ '@media print': { display: 'none' } }}>
        <MarketLeaderboardCard
          rows={selectedWeek?.rows ?? []}
          resolvedWeek={selectedWeek?.weekStart ?? ''}
          availableWeeks={availableWeeks}
          currencySymbol={currencySymbol}
          selectedCountries={selectedCountries}
          accountIds={scope.accountIds ?? []}
          isLoading={isLoading}
          onWeekChange={setWeekStart}
          topMarkets={topMarkets}
          coverage={selectedWeek?.coverage ?? null}
        />
      </Box>

      <Box sx={{ display: 'none', '@media print': { display: 'block' } }}>
        {weeks
          .filter((week) => filterByCountries(week.rows, selectedCountries).length > 0)
          .map((week) => (
            <MarketLeaderboardCard
              key={week.weekStart}
              rows={week.rows}
              resolvedWeek={week.weekStart}
              availableWeeks={availableWeeks}
              currencySymbol={currencySymbol}
              selectedCountries={selectedCountries}
              accountIds={scope.accountIds ?? []}
              isLoading={false}
              coverage={week.coverage}
              printPage
            />
          ))}
      </Box>
    </>
  );
}
